import { getPageSize } from "./selectors";

const getPreviousPageNumber = ({ offset: { lower } }) =>
  Math.floor((lower - 1) / getPageSize()) + 1;

export default getPreviousPageNumber;
